import { Component, ViewEncapsulation } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { SubPOOrderInfo } from '@app/cp/shared/models/SubPOOrderInfo';

@Component({
    selector: 'subpo-orderinfo',
    templateUrl: './subpo-orderinfo.component.html',
    styleUrls: ['./subpo-orderinfo.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SubPOOrderInfoComponent extends BaseGridUIComponent<SubPOOrderInfo, null, ConstructionService >  {

    constructor(svc_data: ConstructionService, globals: GlobalsService) {
        super(globals);
        this.svc_data = svc_data;
  }
    subPOOrderInfo: SubPOOrderInfo;

    getData() {
//        this.clear();
        this.svc_data.getSubcoOrderBillDollarInfo(this._id).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                this.subPOOrderInfo = info.primaryReturn;
                this.select(this.subPOOrderInfo);
            }
        })
    }
    clear(clearId: boolean = true) {
        super.clear(clearId);
        this.subPOOrderInfo = new SubPOOrderInfo();
    }
}
